module.exports = __webpack_public_path__ + "img/Apps_Android.4d98a680.png";